export enum AdvisorViewStatus {
  PendingApproval = 'pending_approval',
  PendingExecution = 'pending_execution',
  PartiallyFilled = 'partially_filled',
  Rejected = 'rejected',
  Filled = 'filled',
  Canceled = 'canceled',
}
